import de from "~/lang/de-DE";
import en from "~/lang/en-US";
import es from "~/lang/es-ES";
import it from "~/lang/it-IT";
import nl from "~/lang/nl-NL";

export default {
  ...en,
  ...de,
  ...es,
  ...it,
  ...nl,
};
